import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, Select, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { SelectPlaceholder } from '../selectPlaceholder';
export const EmptySelect = t0 => {
  const $ = _c(11);
  const {
    title,
    size: t1,
    value,
    labelAdornment
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  let t2;
  if ($[0] !== labelAdornment || $[1] !== title) {
    t2 = title && (labelAdornment ? <Stack direction="row" className="mb-[8px]" sx={{
      alignItems: "center",
      gap: "4px"
    }}><FormLabel className="m-0">{title}</FormLabel>{labelAdornment}</Stack> : <FormLabel>{title}</FormLabel>);
    $[0] = labelAdornment;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== value) {
    t3 = () => <SelectPlaceholder title={value} />;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== size || $[6] !== t3) {
    t4 = <Select size={size} displayEmpty={true} renderValue={t3} disabled={true} value="" />;
    $[5] = size;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <FormControl size="small" className="flex-1">{t2}{t4}</FormControl>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};